import { Navigate } from "react-router-dom";
import { useCurrentUser } from "../api/hooks/auth";
import { Spin } from "antd";

const ProtectedRoute = ({ children, permissions = [] }) => {
  const { data: userData, isLoading } = useCurrentUser();

  if (isLoading) {
    return <Spin />;
  }

  // If no user data or not authenticated, redirect to login
  if (!userData) {
    return <Navigate to="/auth/login" replace />;
  }

  // If all checks pass, render the protected component

  if (
    permissions.some((permission) => {
      return userData?.type?.permissions?.[permission];
    })
  ) {
    return children;
  }

  return <Navigate to="/dashboard" replace />;
};

export default ProtectedRoute;
